import React, { useState, useEffect } from 'react'
import { Container } from './styled'
import { useTranslation } from 'react-i18next'
import { Grid, Button, Modal, Typography, Box, Fab } from '@mui/material'
import NoResultsPlaceholder from 'components/organisms/noResultsPlaceholder/view'
import { ModalContent, BookingModalContent } from './styled'
import { EditorState  } from 'draft-js';
import { convertToHTML } from 'draft-convert';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { getBookingPlans, acceptBooking, createBookingPlan, getVenuePrice } from 'api'
import dayjs from 'dayjs';
import Cancel from '@mui/icons-material/Cancel';
import CheckCircle from '@mui/icons-material/CheckCircle';
import GroupBookingForm from '../groupBookingForm/view';
import { DayCalendarSkeleton } from '@mui/x-date-pickers/DayCalendarSkeleton';
import { loadStripe } from '@stripe/stripe-js';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import Badge from '@mui/material/Badge';
import { REACT_APP_STRIPE_KEY } from 'config/api';
import AddIcon from '@mui/icons-material/Add';

const BookingPlanList = ({ slug, communities }) => {

  const { t } = useTranslation()
  const [bookings, setBookings] = useState([])
  const [message] = useState('')
  const [formData, setFormData] = useState({})
  const [theBooking, setBooking] = useState({})
  const [messageEditorState] = useState(EditorState.createEmpty())
  const [openConfirm, setOpenConfirm] = useState(false)
  const [bookingConfirm, setBookingConfirm] = useState(false)
  const [confirmAction, setConfirmAction] = useState({})
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [sessionId, setSessionId] = useState(null)
  const stripePromise = REACT_APP_STRIPE_KEY ? loadStripe(REACT_APP_STRIPE_KEY) : null;
  const [prices, setPrices] = useState([])

  const [highlightedDays, setHighlightedDays] = useState([1, 5, 7, 10, 20, 27])
  const [isLoading, setIsLoading] = useState(false);

  function ServerDay(props) {
    const { day, outsideCurrentMonth, ...other } = props;

    // Check if prices is an array
    if (!Array.isArray(prices)) {
      return null; // or handle it in a way that makes sense for your application
    }
    // Check if there is a price for the current day
    const priceInfo = prices?.find((price) => {
      const priceDate = new Date(price.start);
      return priceDate.toISOString().split('T')[0] === props.day.format('YYYY-MM-DD');
    });

    return (
      <Badge
        key={props.day.toString()}
        overlap="circular"
        badgeContent={priceInfo ? `£${priceInfo?.price}` : undefined}
      >
        <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
      </Badge>
    );
  }

  const doBooking = () => {
    const formattedDate = selectedDate.format('DD/MM/YYYY');

    const data = {
      title: formData.title,
      description: formData.description,
      venue: slug,
      group: formData.group,
      date: formattedDate,
      number_spaces: formData.spaces,
      booking_type: 'HD',
      price: formData.price,
      fee: formData.fee,
    }
    createBookingPlan(data).then(r => {
      setSessionId(r.sessionId)
      setBookingConfirm(false)
    })
      .catch(console.error)

  };

  function getVenuePricesInfo() {
    getVenuePrice(slug).then(r => {
      setPrices(r.prices)
    })
      .catch(console.error)
  }

  function doAcceptBooking(slug, action) {
    setConfirmAction({ slug, action })
    setOpenConfirm(true)

  }

  function doConfirm() {
    acceptBooking(confirmAction).then(() => {
      fetchBookings()
      setOpenConfirm(false)
    }).catch(console.error)
  }

  const handleMonthChange = () => {
    setIsLoading(true);
    setHighlightedDays([]);
    //fetchHighlightedDays(date);
    setIsLoading(false);
  };

  function fetchBookings() {
    getBookingPlans(slug).then(r => {
      setBookings(r?.bookings)
    })
  }



  useEffect(() => {
    fetchBookings()
    getVenuePricesInfo(true)
  }, [])

  useEffect(() => {
    if (sessionId != null) {
      const redirectToCheckout = async () => {
        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
          sessionId: sessionId,
        });

        if (error) {
          console.error(error.message);
          // Handle the error, e.g., display a message to the user
        }
      }
      redirectToCheckout()
    }

  }, [sessionId])

  useEffect(() => {
    const htmlMessage = convertToHTML(messageEditorState.getCurrentContent())
    setBooking({ ...theBooking, message: htmlMessage })
  }, [message])

  return (
    <Container>
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
        <Grid item xs={12} md={12} sx={{ paddingTop: 5 }}>
          {bookings?.length === 0 && (
            <NoResultsPlaceholder firstSentence={t('No bookings found')} lastSentence={t('Create a new booking now')} />
          )}
          {bookings?.length > 0 && (
            <Box sx={{ marginBottom: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={1}><Typography variant="body1">{t('Code')}</Typography></Grid>
                <Grid item xs={1}><Typography variant="body1">{t('Price')}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body1">{t('Day')}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body1">{t('Start')}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body1">{t('End')}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body1">{t('Status')}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body1">{t('Action')}</Typography></Grid>
              </Grid>
            </Box>
          )}
          {bookings?.map((item, index) => {
            return (
              <Grid container spacing={2} key={index} sx={{ marginBottom: 2 }}>
                <Grid item xs={1}><Typography variant="body2">{item?.code}</Typography></Grid>
                <Grid item xs={1}><Typography variant="body2">{item?.price}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body2">{item?.planned_start_day}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body2">{item?.planned_start_time}</Typography></Grid>
                <Grid item xs={2}><Typography variant="body2">{item?.planned_end_time}</Typography></Grid>
                <Grid item xs={2} sx={{ overflow: 'ellipsis' }}>{item?.status}<Typography variant="body2">{item?.subject}</Typography></Grid>
                <Grid item xs={2}>
                  {item?.status === 'PN' && <Box display="flex" alignItems="center">

                    <CheckCircle color="success" sx={{ marginLeft: 2, fontSize: '24px', cursor: 'pointer' }} onClick={() => doAcceptBooking(item?.slug, 'accept')} />
                    <Cancel color="error" sx={{ marginLeft: 2, fontSize: '24px', cursor: 'pointer' }} onClick={() => doAcceptBooking(item?.slug, 'reject')} />
                  </Box>}
                </Grid>
              </Grid>
            )
          }
          )}
        </Grid>
      </Grid>
      <Fab
        color="primary"
        aria-label="add"
        sx={{ position: 'fixed', bottom: 16, right: 16 }}
        onClick={() => setBookingConfirm(true)}
      >
        <AddIcon />
      </Fab>
      <Modal
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        aria-labelledby="confirmation-modal-title"
        aria-describedby="confirmation-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <ModalContent>
          <Box>
            <Typography id="confirmation-modal-title" variant="h6" component="h2">
              Booking Confirmation
            </Typography>
            <Typography id="confirmation-modal-description" sx={{ mt: 2 }}>
              Are you sure you want to {confirmAction.action === 'accept' ? 'confirm' : 'reject'} this booking?
            </Typography>
            <Box mt={3} display="flex" justifyContent="space-between">
              <Button variant="contained" color="primary" onClick={() => doConfirm()}>
                {confirmAction.action === 'accept' ? 'Confirm' : 'Reject'}
              </Button>
            </Box>

          </Box>
        </ModalContent>
      </Modal>

      <Modal
        open={bookingConfirm}
        onClose={() => setBookingConfirm(false)}
        aria-labelledby="booking-modal-title"
        aria-describedby="booking-modal-description"
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <BookingModalContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <GroupBookingForm formData={formData} setFormData={setFormData} communities={communities} />
            </Grid>

            <Grid item xs={12} md={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar
                  value={selectedDate}
                  loading={isLoading}
                  onMonthChange={handleMonthChange}
                  renderLoading={() => <DayCalendarSkeleton />}
                  slots={{
                    day: ServerDay,
                  }}
                  slotProps={{
                    day: {
                      highlightedDays,
                    },
                  }}
                  onChange={(newValue) => setSelectedDate(newValue)}
                />
              </LocalizationProvider>

              <Button variant='contained' color='button_color' onClick={() => doBooking()}>Book</Button>
            </Grid>
          </Grid>
        </BookingModalContent>
      </Modal>
    </Container >
  )
}

BookingPlanList.propTypes = {

}

export default BookingPlanList
